import { render, staticRenderFns } from "./contributions.vue?vue&type=template&id=138f0b5c&scoped=true&"
import script from "./contributions.vue?vue&type=script&lang=js&"
export * from "./contributions.vue?vue&type=script&lang=js&"
import style0 from "./contributions.vue?vue&type=style&index=0&id=138f0b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f0b5c",
  null
  
)

export default component.exports